import { render, staticRenderFns } from "./LDQuickMenu.vue?vue&type=template&id=ae7957d8&scoped=true"
var script = {}
import style0 from "./LDQuickMenu.vue?vue&type=style&index=0&id=ae7957d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7957d8",
  null
  
)

export default component.exports